import { render, staticRenderFns } from "./FormCulture.vue?vue&type=template&id=2511b564"
import script from "./FormCulture.vue?vue&type=script&lang=js"
export * from "./FormCulture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports